import { Link } from "@tanstack/react-router";

import type { BlogListingLoaderData } from "../route-data";
import { BlogFilters } from "@/features/blog/components/blog-filters";
import { Pagination } from "@/features/blog/components/pagination";
import { PostCard } from "@/features/blog/components/post-card";
import { BLOG_COPY } from "@/features/blog/copy";
import { blogIndexLink } from "@/features/blog/links";
import { JoinBand, PageHero } from "@/landing/system/blocks";
import { GlassCard, Section } from "@/landing/system/layout";
import { BLOG_DESCRIPTIONS } from "../route-data";

export function BlogIndexScreen({ data }: { data: BlogListingLoaderData }) {
  const {
    locale,
    availableLocales,
    categories,
    tags,
    posts,
    totalPages,
    currentPage,
    categorySlug,
    tagSlug,
  } = data;
  const copy = BLOG_COPY[locale];
  const isFiltered = Boolean(categorySlug ?? tagSlug);

  return (
    <>
      <PageHero title="Blog" sub={BLOG_DESCRIPTIONS[locale]} cta="none" />

      <Section className="pt-[clamp(36px,4vw,56px)]">
        <BlogFilters
          locale={locale}
          availableLocales={availableLocales}
          categories={categories}
          tags={tags}
          categorySlug={categorySlug}
          tagSlug={tagSlug}
        />

        {posts.length > 0 ? (
          <ul className="m-0 mt-10 grid list-none grid-cols-1 gap-4 p-0 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((post) => (
              <li key={post.slug} className="min-w-0">
                <PostCard post={post} locale={locale} />
              </li>
            ))}
          </ul>
        ) : (
          <GlassCard className="mt-10 max-w-[34rem]">
            <p className="m-0 text-[17px] font-medium tracking-[-0.01em] text-(--g-ink)">
              {isFiltered ? copy.noMatch : copy.noPosts}
            </p>
            {isFiltered && (
              <Link
                {...blogIndexLink(locale)}
                className="mt-3 inline-block text-[15px] text-(--g-ink) underline decoration-(--g-rule) decoration-1 underline-offset-[0.22em] transition-colors hover:decoration-current"
              >
                {copy.seeAll}
              </Link>
            )}
          </GlassCard>
        )}

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          categorySlug={categorySlug}
          tagSlug={tagSlug}
          locale={locale}
        />
      </Section>

      <JoinBand />
    </>
  );
}
